/**
 * Defers the execution of the provided callback function until the next repaint,
 * ensuring that it runs after the current call stack has cleared.
 * @param {Function} callback - The function to be executed after the current call stack.
 * @param {number} [timeout=0] - Optional timeout in milliseconds to delay the execution further.
 * @throws {TypeError} Throws an error if the callback is not a function.
 * @returns {void}
 */
export default function deferAction(callback, timeout = 0) {
  if (typeof callback !== "function") {
    throw new TypeError("Callback must be a function")
  }
  if (!window.requestAnimationFrame) {
    setTimeout(callback, timeout)
  } else {
    requestAnimationFrame(() => {
      setTimeout(callback, timeout)
    })
  }
}
